import { render, staticRenderFns } from "./RadioButtonGroupInput.vue?vue&type=template&id=36d14c56&scoped=true&"
import script from "./RadioButtonGroupInput.vue?vue&type=script&lang=js&"
export * from "./RadioButtonGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d14c56",
  null
  
)

export default component.exports